import React from 'react';
import PropTypes from 'prop-types';

import { LayoutGrid } from 'components/layouts';
import { useHistory } from 'react-router-dom';
import { Card, Progress, Button } from 'antd';

const UncompleteProfile = ({ profilePercentage, progressWidth }) => {
  const history = useHistory();
  return (
    <LayoutGrid>
      <Card
        title="Complete your profile"
        headStyle={{ textAlign: 'center' }}
      >
        <Progress
          type="circle"
          percent={profilePercentage}
          width={progressWidth}
        />
        <Button
          type="primary"
          onClick={() => {
            history.push('/update-profile');
          }}
        >
          Update
        </Button>
      </Card>
    </LayoutGrid>
  );
};

UncompleteProfile.propTypes = {
  profilePercentage: PropTypes.number.isRequired,
  progressWidth: PropTypes.number.isRequired,
};

UncompleteProfile.defaultProps = {};

export default UncompleteProfile;
